/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { useCallback, useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RoutePath } from 'shared/enums/RoutePath';
import { ConfigResourceProps } from '../../../enums/ConfigResourceProps';
import { ThunkStatus } from '../../../enums/ThunkStatus';
import { useConfiguration } from '../../configuration/useConfiguration';
import useEditUserRole from '../editRoles/useEditUserRole';
import { toggleRemoveUserDialog, updateUserId } from '../remove/user.removeFromOrg.slice';
import { selectUser, selectStatus, selectResetUser, updateUser } from './user.edit.slice';
import { editUserData, getUserById } from './user.edit.thunk';
import { selectAuthUserData } from '../../auth/auth.slice';

// !!!!REFACTOR NEEDED
export default function useEditUserProfile(userId) {
  const [isValid, setIsValid] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const { resource: validationSchema } = useConfiguration(ConfigResourceProps.USEREDIT_VALIDATION_SCHEMA);
  const userEditUiSchema = useConfiguration(ConfigResourceProps.USEREDIT_UI_SCHEMA);

  const dispatch = useDispatch();

  const loggedUserData = useSelector(selectAuthUserData);
  const user = useSelector(selectUser);
  const status = useSelector(selectStatus);
  const resetUser = useSelector(selectResetUser);
  const onUpdateUser = newUser => dispatch(updateUser(newUser));

  const { userRoles, onSubmit, onRoleChange, onUpdateUserRoles, editRole, handleEditRoles, disabled } = useEditUserRole(
    userId,
    user,
  );

  const checkIfFormIsValid = (form) => {
    // const { required } = validationSchema;
    const { formData } = form;
    // THIS IS AN ATROCITY, TO REFACTOR WHEN BUSINESS RULES ARE IMPLEMENTED IN THE BE
    // let hasEmptyProperty = false;
    // for (const requiredField of required) {
    //   if (!formData?.[requiredField]) {
    //     hasEmptyProperty = true;
    //   }
    // }

    setIsValid(form.errors?.length === 0 && !form.isInvalid && !!formData.emailAddress);
  };

  const onSubmitEditUser = () => {
    if (userId) {
      dispatch(editUserData({ userId, user }));
      window.location.href = RoutePath.generateRoutePath(RoutePath.USER_PROFILE, { userId });
    }
  };

  const openDialog = () => {
    dispatch(updateUserId(userId));
    dispatch(toggleRemoveUserDialog(true));
  };

  const handleClick = () => {
    setIsEditMode(current => !current);
  };

  useEffect(() => {
    if (resetUser) {
      window.location.href = RoutePath.generateRoutePath(RoutePath.USER_PROFILE, { userId });
    }
  }, [resetUser]);

  useEffect(() => {
    if (userId) dispatch(getUserById(userId));
  }, [userId]);

  useEffect(() => {
    setIsLoading(status === ThunkStatus.LOADING);
  }, [status]);

  const toggleDrawer = useCallback(() => {
    setIsDrawerOpen(!isDrawerOpen);
  }, [isDrawerOpen]);

  const isEditMadeByTheSameUser = useMemo(() => {
    return loggedUserData?.sub === userId;
  }, [userId, loggedUserData]);

  return {
    uiSchema: userEditUiSchema.resource,
    validationSchema,
    user,
    isLoading,
    isValid,
    onSubmitEditUser,
    checkIfFormIsValid,
    onUpdateUser,
    handleClick,
    isEditMode,
    openDialog,
    userRoles,
    onSubmit,
    onRoleChange,
    onUpdateUserRoles,
    editRole,
    handleEditRoles,
    disabled,
    toggleDrawer,
    isDrawerOpen,
    isEditMadeByTheSameUser,
  };
}
